import React from 'react'
import styled from 'styled-components'
import { rgba } from 'polished'
import ScrollAnimation from 'react-animate-on-scroll'

import { white, black } from 'styles/colors'
import { verticalPadding } from 'styles/global'
import { media } from 'styles/media'
import { H3, H2, H4, fontWeights, lineHeights } from 'styles/typography'
import * as spacing from 'styles/spacing'

import Section, { SectionBlock } from 'components/Section'
import Wrapper from 'components/Wrapper'
import Button from 'components/button/Button'

const Container = styled.div`
  position: static;
  text-align: center;
  color: ${white};
  background-color: ${rgba(black, 0.4)};

  ${media.medium`
    ${verticalPadding('2rem')};
  `};

  ${media.xLarge`
    ${verticalPadding('3rem')};
  `};
`

const List = styled.div`
  position: static;
  max-width: 480px;
  margin: ${spacing.medium} auto;

  ${media.small`
    max-width: 560px;
  `};

  ${media.medium`
    max-width: 820px;
    margin-top: ${spacing.large};
    margin-bottom: ${spacing.large};
  `};

  ${media.large`
    max-width: 1100px;
    margin-top: ${spacing.xLarge};
    margin-bottom: ${spacing.xLarge};
  `};

  ${media.xLarge`
    margin-top: ${spacing.xxLarge};
    margin-bottom: ${spacing.xxLarge};
  `};
`

const ListInner = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -12px;

  ${media.small`
    margin: -20px;
  `};

  ${media.medium`
    margin: -24px;
  `};

  ${media.large`
    margin: -30px;
  `};

  ${media.xLarge`
    margin: -40px;
  `};

  ${media.xxLarge`
    margin: -50px;
  `};
`

const Item = styled.div`
  padding: 12px;
  width: 100%;

  ${media.small`
    flex-basis: 50%;
    padding: 20px;
  `};

  ${media.medium`
    flex-basis: 33.333%;
    padding: 24px;

    &:nth-child(1),
    &:nth-child(2) {
      flex-basis: 40%;
    }
  `};

  ${media.large`
    padding: 30px;
  `};

  ${media.xLarge`
    padding: 40px;
  `};

  ${media.xxLarge`
    padding: 50px;
  `};
`

const ItemDescription = styled(H4)`
  position: static;
  text-align: center;
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights.base};
  color: ${white};
  margin: 0;
`

const Heading = styled(H3)`
  color: ${white};
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 0;
`

const StyledButton = styled(Button)`
  min-width: 160px;

  ${media.medium`
    min-width: 240px;
  `};
`

const ItemTitle = styled(H2)`
  font-family: 'Trim Poster';
  color: ${white};
  text-transform: uppercase;
  margin-bottom: ${spacing.tiny};
`

const Plans = () => (
  <Container>
    <Section>
      <Wrapper>
        <SectionBlock>
          <Heading as={ScrollAnimation} animateIn="fadeInUp" offset={0} animateOnce>
            How much can you save
          </Heading>
        </SectionBlock>
        <SectionBlock>
          <List as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={200} animateOnce>
            <ListInner>
              <Item>
                <ItemTitle>20% Off</ItemTitle>
                <ItemDescription>
                  when you build an order with <strong>3 or 4 pod packs</strong> of any pods
                </ItemDescription>
              </Item>
              <Item>
                <ItemTitle>25% Off</ItemTitle>
                <ItemDescription>
                  when you build an order with <strong>5 or more pod packs</strong> of any pods
                </ItemDescription>
              </Item>
              <Item>
                <ItemTitle>Additional 5% Off</ItemTitle>
                <ItemDescription>
                  if you are a <strong>Vuse+ Platinum</strong> member
                </ItemDescription>
              </Item>
              <Item>
                <ItemTitle>Free device</ItemTitle>
                <ItemDescription>
                  for all <strong>Vuse+ members</strong> on first subscription order shipped
                </ItemDescription>
              </Item>
              <Item>
                <ItemTitle>Free shipping</ItemTitle>
                <ItemDescription>save big on every monthly delivery</ItemDescription>
              </Item>
            </ListInner>
          </List>
        </SectionBlock>
        <SectionBlock>
          <ScrollAnimation animateIn="fadeInUp" offset={0} delay={600} animateOnce>
            <StyledButton to="/buy-online/vuse-pods/" theme="custom" customColor={white} variant="outline" size="large">
              Start building an order
            </StyledButton>
          </ScrollAnimation>
        </SectionBlock>
      </Wrapper>
    </Section>
  </Container>
)

export default Plans
